"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
ProfileBasicController.$inject = ['$scope', 'api', '_profile', 'notify'];
function ProfileBasicController($scope, api, _profile, notify) {
    _profile.get().then(function (data) {
        $scope.company = data.company;
        $scope.user = _.create(data.user);
    });
    $scope.save = function () {
        _profile.saveUser($scope.user).then(function (response) {
            console.log(response);
            notify.success('Uspešno ste sačuvali podatke.');
        }, function (error) {
            console.log(error);
            notify.error(error.data);
        });
    };
}
exports.ProfileBasicController = ProfileBasicController;



//////////////////
// WEBPACK FOOTER
// ./scripts/apps/profile/controllers/ProfileBasicController.js
// module id = 434
// module chunks = 0